/** @format */

import React from "react";
import Button from "../../extra/Button";
import { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getCategory, deleteCategory, updateCategorySortOrder } from "../../store/category/category.action";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import CategoryDialog from "./CategoryDialog";
import { warning } from "../../../util/Alert";
import { useNavigate } from "react-router-dom";
import Pagination from "../../extra/Pagination";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { colors } from "../../../util/SkeletonColor";
import { useState } from "react";
import Iconb from "../../extra/Iconb";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import defaultImage from "../../../assets/images/default.jpg";
import { getImageUrl } from "../../../util/getImageUrl";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

const Category = (props) => {
	const [page, setPage] = useState(0);
	const [data, setData] = useState([]);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [loading, setLoading] = useState(true);
	const { category } = useSelector((state) => state.category);
	const { dialogue, dialogueType } = useSelector((state) => state.dialogue);

	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(getCategory());
	}, [dispatch]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setLoading(false);
		}, 1500);
		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		setData(category);
	}, [category]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event, 10));
		setPage(0);
	};

	const handleDelete = (id) => {
		const data = warning();
		data.then((isDeleted) => {
			if (isDeleted) {
				dispatch(deleteCategory(id));
			}
		}).catch((err) => console.log(err));
	};

	const handleDragEnd = (result) => {
		if (!result.destination) return;
		const srcIndex = result.source.index;
		const destIndex = result.destination.index;
		if (srcIndex === destIndex) return;

		// Calculate actual indices based on page
		const actualSrc = page * rowsPerPage + srcIndex;
		const actualDest = page * rowsPerPage + destIndex;

		const reordered = Array.from(data);
		const [moved] = reordered.splice(actualSrc, 1);
		reordered.splice(actualDest, 0, moved);

		setData(reordered);
		dispatch(updateCategorySortOrder(reordered.map((c) => c._id)));
	};

	const pageData = rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data;

	return (
		<>
			<div className='mainSellerTable'>
				<div className='sellerTable'>
					<div className='col-12 headname'>Category </div>
					<div className='sellerMain'>
						<div className='tableMain mt-2 categoryTable'>
							<div className='sellerHeader primeHeader'>
								<div className='row'>
									<div className='col-12'>
										<Button
											newClass={`whiteFont`}
											btnColor={`btnBlackPrime `}
											btnIcon={`fa-solid fa-plus `}
											btnName={`Add`}
											onClick={() => {
												dispatch({
													type: OPEN_DIALOGUE,
													payload: { type: "Category" },
												});
											}}
											style={{ borderRadius: "8px", padding: "8px 32px", background: "#e54a13" }}
										/>
										{dialogue && dialogueType === "Category" && <CategoryDialog />}
									</div>
								</div>
							</div>
							<div className='primeMain'>
								<DragDropContext onDragEnd={handleDragEnd}>
									<table width='100%' className='primeTable text-center' style={{ maxHeight: "600px" }}>
										<thead className='sticky-top' style={{ top: "-1px", zIndex: "1" }}>
											<tr>
												<th className='fw-bold py-3' style={{ width: "40px" }}></th>
												<th className='fw-bold py-3' style={{ width: "40px" }}>
													No
												</th>
												<th className='fw-bold py-3'>Image</th>
												<th className='fw-bold py-3'>Category</th>
												<th className='fw-bold py-3'>Product</th>
												<th className='fw-bold py-3'>Sub Category</th>
												<th className='fw-bold py-3'>Add SubCategory</th>
												<th className='fw-bold py-3'>Edit</th>
												<th className='fw-bold py-3'>Delete</th>
												<th className='fw-bold py-3'>Info</th>
											</tr>
										</thead>
										<Droppable droppableId='categories'>
											{(provided) => (
												<tbody ref={provided.innerRef} {...provided.droppableProps}>
													{loading ? (
														<tr>
															<td colSpan='10'>
																<div className='mainLoaderBox'>
																	<div className='loader'></div>
																</div>
															</td>
														</tr>
													) : pageData.length === 0 ? (
														<tr>
															<td colSpan='10' className='text-center py-5' style={{ color: "#94a3b8" }}>
																<i className='bi bi-inbox' style={{ fontSize: "28px", display: "block", marginBottom: "8px" }}></i>
																No Data Found
															</td>
														</tr>
													) : (
														pageData.map((row, index) => (
															<Draggable key={row._id} draggableId={row._id} index={index}>
																{(provided, snapshot) => (
																	<tr
																		ref={provided.innerRef}
																		{...provided.draggableProps}
																		style={{
																			...provided.draggableProps.style,
																			background: snapshot.isDragging ? "#fff4f0" : "transparent",
																			boxShadow: snapshot.isDragging ? "0 4px 16px rgba(229,74,19,0.15)" : "none",
																		}}>
																		<td {...provided.dragHandleProps} style={{ cursor: "grab", width: "40px" }}>
																			<DragIndicatorIcon sx={{ color: "#94a3b8", fontSize: 20 }} />
																		</td>
																		<td>
																			<span className='fw-normal'>{page * rowsPerPage + index + 1}</span>
																		</td>
																		<td>
																			<img
																				src={getImageUrl(row.image) || defaultImage}
																				style={{ borderRadius: "10px", cursor: "pointer" }}
																				height={45}
																				width={45}
																				alt='category'
																				onClick={() =>
																					navigate("/admin/category/subCategory", {
																						state: { id: row?._id },
																					})
																				}
																				onError={(e) => {
																					e.target.onerror = null;
																					e.target.src = defaultImage;
																				}}
																			/>
																		</td>
																		<td>
																			<p className='mb-0 text-capitalize fw-normal'>{row.name}</p>
																		</td>
																		<td>
																			<p className='mb-0'>{row.categoryProduct || 0}</p>
																		</td>
																		<td>
																			<p className='mb-0 fw-normal'>{row?.totalSubcategory || 0}</p>
																		</td>
																		<td>
																			<div
																				style={{ cursor: "pointer" }}
																				onClick={() =>
																					navigate("/admin/category/subCategory", {
																						state: { id: row?._id },
																					})
																				}>
																				<svg width='24' height='24' fill='none' stroke='#5a5a5aff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' viewBox='0 0 24 24'>
																					<line x1='12' y1='5' x2='12' y2='19' />
																					<line x1='5' y1='12' x2='19' y2='12' />
																				</svg>
																			</div>
																		</td>
																		<td>
																			<Iconb
																				newClass={`themeFont boxCenter infobtn userBtn fs-5`}
																				btnIcon={<CreateOutlinedIcon sx={{ color: "#64748b" }} />}
																				style={{ borderRadius: "10px", margin: "auto", height: "45px", width: "45px", color: "#64748b" }}
																				isImage={true}
																				onClick={() => {
																					dispatch({
																						type: OPEN_DIALOGUE,
																						payload: { data: row, type: "Category" },
																					});
																				}}
																			/>
																		</td>
																		<td>
																			<Iconb newClass={`themeFont boxCenter killbtn userBtn fs-5`} btnIcon={<DeleteIcon sx={{ color: "#FF4C51" }} />} style={{ borderRadius: "10px", margin: "auto", height: "45px", width: "45px", color: "#64748b", padding: "0px" }} isImage={true} isDeleted={true} onClick={() => handleDelete(row?._id)} />
																		</td>
																		<td>
																			<Iconb
																				newClass={`themeFont boxCenter infobtn userBtn fs-5`}
																				btnIcon={<InfoOutlined sx={{ color: "#64748b" }} />}
																				style={{ borderRadius: "10px", margin: "auto", height: "45px", width: "45px", color: "#64748b", padding: "0px" }}
																				isImage={true}
																				isDeleted={true}
																				onClick={() =>
																					navigate("/admin/category/subCategory", {
																						state: { id: row?._id },
																					})
																				}
																			/>
																		</td>
																	</tr>
																)}
															</Draggable>
														))
													)}
													{provided.placeholder}
												</tbody>
											)}
										</Droppable>
									</table>
								</DragDropContext>
							</div>
							<Pagination component='div' count={category?.length} serverPage={page} type={"client"} onPageChange={handleChangePage} serverPerPage={rowsPerPage} totalData={category?.length} onRowsPerPageChange={handleChangeRowsPerPage} style={{ display: "flex", justifyContent: "start" }} />
						</div>
					</div>
					<div className='sellerFooter primeFooter'></div>
				</div>
			</div>
		</>
	);
};

export default connect(null, {
	getCategory,
	deleteCategory,
	updateCategorySortOrder,
})(Category);
